import { render } from "./DbsCouponTicketsRadio.vue?vue&type=template&id=24a4563d&scoped=true"
import script from "./DbsCouponTicketsRadio.vue?vue&type=script&lang=js"
export * from "./DbsCouponTicketsRadio.vue?vue&type=script&lang=js"

import "./DbsCouponTicketsRadio.vue?vue&type=style&index=0&id=24a4563d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24a4563d"

export default script